// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

// import conponents
import LoginPage from '@/components/LoginPage.vue';
import DashB from '@/components/DashB.vue';
import UserList from '@/components/UserList.vue';
import OnlineUserList from '@/components/OnlineUserList.vue';
import CoinRecord from '@/components/CoinRecord.vue';
import GameRecord from '@/components/GameRecord.vue';
import WithdrawTX from '@/components/WithdrawTX.vue';
import CSList from '@/components/CSList.vue';
import CS from '@/components/CS.vue';
import WeChat from '@/components/WeChat.vue';

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { 
      title: 'login'
    }
  },
  {
    path: '/dashb',
    name: 'DashB',
    component: DashB,
    meta: { 
      title: '',
      showNav:true
    }
  },
  {
    path: '/userlist',
    name: 'UserList',
    component: UserList,
    meta: { 
      title: '',
      showNav:true
    }
  },
  {
    path: '/onlineuserlist',
    name: 'OnlineUserList',
    component: OnlineUserList,
    meta: { 
      title: '',
      showNav:true
    }
  },
  {
    path: '/coinr',
    name: 'CoinRecord',
    component: CoinRecord,
    meta: { 
      title: '',
      showNav:true
    }
  },

  {
    path: '/gamer',
    name: 'GameRecord',
    component: GameRecord,
    meta: { 
      title: '',
      showNav:true
    }
  },
  {
    path: '/withdrawtx',
    name: 'WithdrawTX',
    component: WithdrawTX,
    meta: { 
      title: '',
      showNav:true
    }
  },
  {
    path: '/cslist',
    name: 'CSList',
    component: CSList,
    meta: { 
      title: '',
      showNav:true
    }
  },
  {
    path: '/cs',
    name: 'CS',
    component: CS,
    meta: { 
      title: '',
      showNav:true
    }
  },
   {
    path: '/wechat',
    name: 'WeChat',
    component: WeChat,
    meta: { 
      title: 'WeChat',
      showNav:false
    }  
  }, 
  {
    path: '/',
    redirect: 'login'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // 设置标题
  document.title = to.meta.title || '默认标题'; // 回退默认值
  next();
});

export default router;